import { render, staticRenderFns } from "./account-selector.vue?vue&type=template&id=67b78934&scoped=true"
import script from "./account-selector.vue?vue&type=script&setup=true&lang=js"
export * from "./account-selector.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b78934",
  null
  
)

export default component.exports